import { MDBIcon } from "mdb-react-ui-kit";
import { useContext, useState } from "react";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import CategoryList from "./business-skills/categories/CategoryList";
import CategoryPicker from "./business-skills/categories/CategoryPicker";
import SubmitNewCategory from "./business-skills/categories/SubmitNewCategory";


export default function BusinessSkillsSection() {

    const [ isVisible, setIsVisible ] = useState( false );
    const { translations } = useContext( TranslationContext );

    return (
        <div className="text-white">
            <div className="subtitre-cv-container text-underline d-flex align-items-center gap-2"
                 onClick={ () => setIsVisible( !isVisible ) }
                 style={ { cursor: "pointer" } }
            >
                <h4 className="text-underline pt-2 text-white">{ translations.businessSkillsSection.title }</h4>
                <div className="line bg-white"></div>
                <MDBIcon
                    fas
                    icon={ "trophy" }
                    style={ { color: "white" } }
                    size="lg"
                />
            </div>
            { isVisible && (
                <>
                    <SubmitNewCategory/>
                    <CategoryPicker/>
                    <CategoryList/>
                </>
            ) }
        </div>
    );
}

